import { Component } from '@angular/core';
import { AppLoadService, IContact, IUser } from '@ebb-v2/ebb-integration';
import { AuthenticationService } from './data-services/authentication.service';

@Component({
  selector: 'ebb-v2-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class TrainingAppComponent {
  title = 'ebb-app-training';


  constructor(

  ) {
   
 
  }

 
}
